export const billInitailState = {
  billDetails: null,
  autoPayDetails: null,
  intialAutoPayDetails: null,
  autoPayEnabled: false,
  isEditing: false,
  autoPayAmoutChanged: false,
  autoPayMethodChanged: false,
  remindersData: null,
};
